// src/components/founderDashboard/FounderLogin.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../founderDashboard/apiClient"

export default function FounderLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      // adjust to match your real login payload/response
      const res = await api.post("/auth/login/", { email, password }); // see baseURL section below

      localStorage.setItem("founder_access_token", res.data.token);
      // no refresh token in your response, so remove this:
      localStorage.removeItem("founder_refresh_token");
      if (res.data.refresh) localStorage.setItem("founder_refresh_token", res.data.refresh);

      // Quick check: hit a founder endpoint to confirm access
      await api.get("/founder-portal/overall-usage/");
      nav("/founder/today");
    } catch (e: any) {
      const status = e?.response?.status;
      if (status === 403) setErr("Not authorised (founder access required).");
      else setErr(e?.response?.data?.detail || "Login failed.");
      localStorage.removeItem("founder_access_token");
      localStorage.removeItem("founder_refresh_token");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: "40px auto", padding: 16 }}>
      <h2>Founder Login</h2>
      <form onSubmit={submit}>
        <label>Email</label>
        <input type="email" autoCapitalize="none" autoCorrect="off" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: "100%" }} />

        <label style={{ marginTop: 12, display: "block" }}>Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: "100%" }} />

        {err && <p style={{ color: "crimson" }}>{err}</p>}

        <button disabled={loading} style={{ marginTop: 16 }}>
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
